module.exports = __webpack_public_path__ + "media/images/logo_white-83c8d34d44136d6135e97d471b1b9331.png";